<div fxFlexFill fxLayout="column" class="content">
  <div fxFlex="100" fxFill class="background-flex50"></div>
  <!-- Login Mobile  -->
  <div fxShow="true" fxHide.gt-xs="true" class="float" fxLayout="column">
    <input
      class="modules"
      type="checkbox"
      id="modules"
      name="modules"
      hidden
      [attr.checked]="!connectModule ? 'checked' : null"
    />
    <div fxFlexFill fxLayout="row" class="toggle-container">
      <label fxFlex="50" class="selector" for="modules">
        <mat-icon>receipt</mat-icon></label
      >
      <label fxFlex="50" for="modules">
        <mat-icon>local_shipping</mat-icon></label
      >
    </div>
  </div>

  <!-- Login Desktop -->
  <div
    fxHide="true"
    fxShow.gt-xs="true"
    fxLayout="column"
    class="container float right-panel-active"
    id="container"
  >
    <div fxLayout="column" fxLayoutAlign="center center" class="login-wrapper">
      <mat-card class="login-card">
        <div class="login-image">
          <img src="assets/imagenes/moto_connect.png" alt="Courier Image" />
          <div class="login-badge">CONNECT</div>
        </div>
        <div>
          <ng-container *ngTemplateOutlet="renderEveryWhere"></ng-container>
        </div>
      </mat-card>
    </div>
  </div>
</div>

<ng-template #renderEveryWhere>
  <form
    fxFlexFill
    [formGroup]="inicioSesionForm"
    (ngSubmit)="onSubmit(inicioSesionForm.value)"
  >
    <mat-card-content>
      <mat-form-field
        hintLabel="Máximo 100 caracteres"
        appearance="outline"
        class="full-width"
      >
        <mat-label>Usuario</mat-label>
        <input
          #Usuario
          formControlName="Usuario"
          matInput
          placeholder="Escriba un nombre de usuario"
        />
        <mat-icon matSuffix>person</mat-icon>
        <mat-hint align="end">{{ Usuario?.value?.length! || 0 }}/100</mat-hint>
        <mat-error *ngIf="inicioSesionForm.controls['Usuario'].invalid">{{
          getErrorMessage(inicioSesionForm.controls["Usuario"])
        }}</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Contraseña</mat-label>
        <input
          formControlName="Contrasena"
          matInput
          [type]="hide ? 'password' : 'text'"
          placeholder="Escriba una contraseña"
        />
        <button
          type="button"
          mat-icon-button
          matSuffix
          (click)="hide = !hide"
          [attr.aria-label]="'Hide password'"
          [attr.aria-pressed]="hide"
        >
          <mat-icon>{{ hide ? "visibility_off" : "visibility" }}</mat-icon>
        </button>
        <mat-hint>Requerido</mat-hint>
        <mat-error *ngIf="inicioSesionForm.controls['Contrasena'].invalid">{{
          getErrorMessage(inicioSesionForm.controls["Contrasena"])
        }}</mat-error>
      </mat-form-field>
    </mat-card-content>
    <mat-card-actions>
      <button
        [style.margin]="0"
        class="full-width"
        type="submit"
        mat-raised-button
        color="primary"
      >
        Iniciar sesión
      </button>
    </mat-card-actions>
  </form>
</ng-template>
